import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MerchantPaymentMethodModalComponent } from './merchant-payment-method-modal/merchant-payment-method-modal.component';
import { GetMerchantPayoutAccountResponseDto } from '../../../../models/lokal/get-payout-account-response';
import { PayoutAccountTypeEnum, PayServiceTypeEnum } from 'app/models';

@Component({
  selector: 'merchant-payment',
  templateUrl: './merchant-payment.component.html',
  styleUrls: ['./merchant-payment.component.css',
    '../merchant-store-onboarding.component.scss',
    '../../../../../styles/m3-defaul-material-theme.scss']
})
export class MerchantPaymentComponent implements OnInit {
  @Output() private showMerchantPaymentGrid = new EventEmitter<boolean>(false);
  @Output() private showPayoutData = new EventEmitter<any>();
  @Input() merchantId: number = 0;

  dialog = inject(MatDialog);

  currentPayment: GetMerchantPayoutAccountResponseDto = {
    MerchantId: 0,
    UsePaymayaAccount: false,
    PayoutAccountTypeId: PayoutAccountTypeEnum.None,
    AccountName: '',
    AccountNumber: '',
    RejectReason: '',
    PayServiceId: PayServiceTypeEnum.None,
    PayServiceName: ''
  };

  constructor() { }

  ngOnInit() {
  }

  showPaymentSetup(){
    this.showMerchantPaymentGrid.emit(true);
  }

  showCreatePaymentMethodDialog(){
    if(this.currentPayment.MerchantId > 0){
      this.showPaymentSetup();
      return;
    }

    const addPaymentDialog = this.dialog.open(MerchantPaymentMethodModalComponent, { width: '70%',
      maxWidth: '1000px',
      disableClose: true,
      data:{
        isCreate: true,
        header: 'Add',
        merchantId: this.merchantId
      }
    });

    addPaymentDialog.afterClosed().subscribe(result => {
      if(result){
        this.showPaymentSetup();
        this.showPayoutData.emit();
      }
    });
  }
}
